<template>
  <div class="left-menu" :class="{ min: isCollapse }">
    <!-- :default-active="defaultActive" -->
    <el-menu
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      style="padding-bottom: 60px"
      :collapse="isCollapse"
    >
      <template v-for="(item,idx) in leftMenu"   v-if="!item.meta.secondMenuKey">
        <div class="submenu">
          <p class="title">
            <i v-if="item.meta && item.meta.menuIcon" :class="item.meta.menuIcon"></i>
            <span>{{ item.meta ? item.meta.menuTitle : "" }}</span>
          </p>
          <div class="childrenT">
            <!-- <p :class="child.name==$route.name ? 'childCk' : ''" v-if="isHasRouter(child) && child.name && !child.meta.secondMenuKey" v-for="(child, i) in item.children" -->
            <p :class="isCheck(child)" v-if="isHasRouter(child) && child.name && !child.meta.secondMenuKey" v-for="(child, i) in item.children"
              :key='i' @click="geRouter(child)">
              {{ child.meta ? child.meta.menuTitle : "" }}  
            </p>
          </div>
        </div>
        <!-- <el-submenu
          v-if="
            item.children &&
            (isHasRouter(item) || item.children.filter((e) => isHasRouter(e)).length)
          "
          :index="item.name"
        >
          <template slot="title">
            <i v-if="item.meta && item.meta.menuIcon" :class="item.meta.menuIcon"></i>
            <span>{{ item.meta ? item.meta.menuTitle : "" }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(child, i) in item.children"
              :key='i'
              v-if="isHasRouter(child) && child.name && !child.meta.secondMenuKey"
              :index="child.name"
              @click.native.stop="geRouter(child)"
              >{{ child.meta ? child.meta.menuTitle : "" }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-else-if="isHasRouter(item)" @click.native="geRouter(item)" :index="item.name">
          <i v-if="item.meta.menuIcon" :class="item.meta.menuIcon"></i>
          <span slot="title">{{ item.meta ? item.meta.menuTitle : "" }}</span>
        </el-menu-item> -->
      </template>
    </el-menu>
  </div>
</template>
<script>
import jurisdictionMenu from "@/mixins/jurisdictionMenu";
import { mapState } from "vuex";
export default {
  mixins: [jurisdictionMenu],
  data() {
    return {
      defaultActive: "",
      leftMenu: [],
    };
  },
  props: ["isCollapse", "menuArr"],
  computed: {
    isCheck(){
      return function(item){
        if(item.name==this.$route.name){
          return 'childCk'
        }
        if(this.$route.meta.secondMenuKey){
          if(item.name==this.$route.meta.secondMenuKey){
            return 'childCk'
          }
        }
      }
    },
    currentRouter() {
      return this.$route;
    },
    routerName() {
      return this.$route.name;
    },
  },
  watch: {
    routerName: {
      handler() {
        this.defaultActive =
          this.currentRouter.meta.secondMenuKey || this.currentRouter.name || "";
        if (!this.isHasRouter({ name: this.routerName })) {
          this.$message({
            message: "对不起，暂无权限",
            type: "warning",
          });
          this.$router.push({
            name: "login",
          });
        }
      },
      immediate: true,
    },
    menuArr: {
      handler() {
        this.leftMenu = [];
        setTimeout(() => {
          // console.log(this.menuArr,3333333333333);
          this.leftMenu = this.menuArr;
        }, 0);
      },
      immediate: true,
    },
  },
  methods: {
    geRouter(item) {
      this.$router.push({
        name: item.name,
      });
    },
    isHasRouter(item) {
      return true
      // console.log(this.jurisdictionMenu,1111111111);
      // return item.name == 'workbench' || this.jurisdictionMenu.filter((e) => item.name == e.name).length;
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.left-menu {
  position: fixed;
  left: 0;
  top:58px;
  border-right: solid 1px #e6e6e6;
  z-index: 20;
  height: 100%;
  overflow: auto;
  transition: 0.5s all;
  width: 262px;
  padding-top: 16px;
  background: #ffffff;
  &.min {
    width: 64px;
  }
  .el-menu {
    border: 0;
    /deep/ .el-menu-item {
      height: 42px;
      line-height: 42px;
      margin-bottom: 4px;
      &.is-active {
        background: #eaf3fd;
        border-right: 4px solid #419eff;
      }
    }
    /deep/ .el-menu-item-group__title {
      padding: 0;
    }
    /deep/ .el-submenu .el-menu-item {
      min-width: 100px;
    }
    .el-submenu__title {
      height: 50px;
      line-height: 50px;
    }
  }
}
.submenu{
  padding:0 20px;
  .title{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    i{
      font-size:16px;
      padding-right:10px;
    }
  }
  .childrenT{
    display: flex;
    margin-left:25px;
    padding-top:15px;
    flex-wrap: wrap;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    p{
      width:50%;
      // margin-right:68px;
      margin-bottom:20px;
      &:nth-child(2n){
        margin:0;
        text-align: center;
      }
    }
    .childCk{
      color:#3373FE;
      font-weight: 500;
    }
  }
}
</style>
